"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var FormatFileSizePipe = /** @class */ (function () {
    function FormatFileSizePipe() {
    }
    FormatFileSizePipe_1 = FormatFileSizePipe;
    FormatFileSizePipe.prototype.transform = function (bytes, fractionDigits) {
        if (fractionDigits === void 0) { fractionDigits = 2; }
        if (bytes < 1) {
            return '0 Bytes';
        }
        fractionDigits = fractionDigits < 0 ? 0 : fractionDigits;
        var sizeIndex = Math.floor(Math.log(bytes) / Math.log(FormatFileSizePipe_1.MB_IN_BYTES));
        var formattedSize = parseFloat((bytes / Math.pow(FormatFileSizePipe_1.MB_IN_BYTES, sizeIndex)).toFixed(fractionDigits));
        return formattedSize + " " + FormatFileSizePipe_1.SIZES[sizeIndex];
    };
    var FormatFileSizePipe_1;
    FormatFileSizePipe.MB_IN_BYTES = 1024;
    FormatFileSizePipe.SIZES = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    FormatFileSizePipe = FormatFileSizePipe_1 = __decorate([
        core_1.Pipe({
            name: 'formatFileSize'
        })
    ], FormatFileSizePipe);
    return FormatFileSizePipe;
}());
exports.FormatFileSizePipe = FormatFileSizePipe;
//# sourceMappingURL=format-file-size.pipe.js.map